import { OUR_PRODUCTS_URL } from '../constants/client-url'
import { coverJourneyRoutesMap, salesFunnelJourneyRoutesMap } from '../constants/cover-journey-url'

const isOnCoverJourneyMiddleURL = (pathname = '') => {
  const allJourneyRoutesMap = [...coverJourneyRoutesMap, ...salesFunnelJourneyRoutesMap]
  return allJourneyRoutesMap.some(CJRoute => pathname.includes(CJRoute))
}

/**
 * Go to Plans selection page from any Cover Journey URL on page reload
 */
export const redirectToPlansPageFromJourneyMiddle = () => {
  if (isOnCoverJourneyMiddleURL(window.location.pathname)) {
    window.location.href = OUR_PRODUCTS_URL
  }
}
